import { IFramework, IWebServiceManager, HttpMethod, IUserContext } from "@truckdown/framework";
import { ILocationImageManager } from "./ILocationImageManager";
import { UploadFileResultModel } from "./Models/UploadFileResultModel";

class LocationImageManager implements ILocationImageManager {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;
    private readonly basePath: string = '/locations';

    uploadLogo(locationId: string, file: File): Promise<UploadFileResultModel> {
        const formData = new FormData();
        formData.append("File", file);

        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/upload-logo/' + encodeURIComponent(locationId),
            method: HttpMethod.POST
        }, formData);

        return this.manager.get<UploadFileResultModel>(req);
    }

    uploadImage(locationId: string, file: File): Promise<UploadFileResultModel> {
        const formData = new FormData();
        formData.append("File", file);

        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/upload-image/' + encodeURIComponent(locationId),
            method: HttpMethod.POST
        }, formData);

        return this.manager.get<UploadFileResultModel>(req);
    }

    async removeLogo(locationId: string, id: string): Promise<void> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/logo/' + encodeURIComponent(locationId) + '/' + encodeURIComponent(id),
            method: HttpMethod.DELETE
        });

        var res = await this.manager.send(req);
        if (!res.ok) {
            console.error('Unsuccessful request to remove logo.', res);
        }
    }

    async removeImage(locationId: string, id: string): Promise<void> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/image/' + encodeURIComponent(locationId) + '/' + encodeURIComponent(id),
            method: HttpMethod.DELETE
        });

        var res = await this.manager.send(req);
        if (!res.ok) {
            console.error('Unsuccessful request to remove image.', res);
        }
    }

    async getOriginalLogo(locationId: string, id: string): Promise<Blob | null> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/original-logo/' + encodeURIComponent(locationId) + '/' + encodeURIComponent(id),
            method: HttpMethod.GET
        });

        var res = await this.manager.send(req);
        if (res.ok) {
            return await res.blob();
        }
        return null;
    }

    async getLogo(id: string): Promise<Blob | null> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/logo/' + encodeURIComponent(id),
            method: HttpMethod.GET
        });

        var res = await this.manager.send(req);
        if (res.ok) {
            return await res.blob();
        }
        return null;
    }

    async getImage(id: string): Promise<Blob | null> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/image/' + encodeURIComponent(id),
            method: HttpMethod.GET
        });

        var res = await this.manager.send(req);
        if (res.ok) {
            return await res.blob();
        }
        return null;
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<ILocationImageManager>('ILocationImageManager', (frm) => {
        return new LocationImageManager(frm);
    });
}
